import { useTranslation } from 'react-i18next'
import { find, prop, propEq } from 'ramda'
import getPriceDateOptions, { getWeeklyPriceDateOptions } from '@/utils/price-date-options'
import renderTextField from '../../render-text-field'

const useRentSummary = ({ contract }) => {
  const { price_frequency, price_date_description } = contract
  const { t } = useTranslation()
  const isMonthlyPrice = price_frequency === 'monthly'
  const isWeeklyPrice = price_frequency === 'weekly'
  const priceDateOptions = getPriceDateOptions(t)
  const weeklyPriceDateOptions = getWeeklyPriceDateOptions(t)

  const getLabel = options => prop('label', find(propEq('value', price_date_description), options))

  const getDateDescriptionValue = () => {
    if (isMonthlyPrice) {
      return getLabel(priceDateOptions)
    } else if (isWeeklyPrice) {
      return getLabel(weeklyPriceDateOptions)
    } else {
      return price_date_description
    }
  }

  const renderStandardField = (field, options = {}) => {
    const fields = {
      price: renderTextField({
        ...options,
        item: field,
        contract,
        type: 'currency'
      }),
      price_frequency: renderTextField({
        ...options,
        item: field,
        contract,
        type: 'price_frequency'
      }),
      price_date_description: renderTextField({
        ...options,
        item: field,
        value: getDateDescriptionValue(),
        contract
      })
    }
    return fields[field.name]
  }
  return { renderStandardField }
}

export default useRentSummary
